@let label = labelSg();

<div class="atn-ds-input-field">
  @if (label) {
    <span class="atn-ds-input-field__label"> {{ labelSg() }} </span>
  }
  <div (click)="picker.open()">
    <input
      class="atn-ds-input-field__control"
      placeholder="Choose date"
      [matDatepicker]="picker"
      readonly
      [value]="valueSg()"
      [disabled]="disabledSg()"
      (dateChange)="onDateChangeHandler($event)"
    />
    <mat-datepicker #picker></mat-datepicker>
  </div>
</div>
